import React from 'react';

export default function Right(props) {
  return (
    <svg viewBox="0 0 40 40" {...props}>
      <path d="M16.64 10l10 10-10 10-2.34-2.34L21.95 20l-7.65-7.66z" />
    </svg>
  );
}



// WEBPACK FOOTER //
// ./app/components/icons/right.js